'use client';

import { FC } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Skeleton } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
import { useGetLastNews } from '../../http/client/useGetLastNews';
import { NewsCard } from '../NewsCard';
export const NewsWidget: FC<NewsWidgetProps> = ({
  showButtonLink = true,
  title
}) => {
  const {
    t
  } = useTranslation('common');
  const containerTitle = title || t('screens.newsPageHub.lastNews.title');
  const {
    data: news = [],
    isLoading
  } = useGetLastNews();
  return <WidgetContainer containerId="news" title={containerTitle} buttonLink={!showButtonLink ? null : PATHS.news.index} data-sentry-element="WidgetContainer" data-sentry-component="NewsWidget" data-sentry-source-file="News.tsx">
      {isLoading ? Array.from({
      length: 10
    }).map((_, idx) => <Skeleton key={idx} w="15.5rem" h="12.25rem" borderRadius="xs" />) : news.map(({
      id,
      title,
      category,
      hour,
      slug
    }) => <NewsCard key={id} id={id} category={category} hour={hour} title={title} slug={slug} />)}
    </WidgetContainer>;
};
type NewsWidgetProps = {
  showButtonLink?: boolean;
  title?: string;
};